module.exports = __webpack_public_path__ + "gp.svg?96038497ebf77dc8e51874ca4a19e9b2";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gp.svg
// module id = 820
// module chunks = 27